export default __webpack_public_path__ + "static/media/nature.fd6da57f.jpg";